// extracted by mini-css-extract-plugin
export default {"agbPageContainer":"AgePage_agbPageContainer__72VPU","agbContainer":"AgePage_agbContainer__+UmuK","agbText":"AgePage_agbText__0X6a4"};